// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { TrackingModel } from "../base/tracking-model";

export class EmailMessage extends TrackingModel {
	public EmailMessageId: number = 0;
	public FromEmailAddress: string = "";
	public Subject: string = "";
	public Body?: string;
	public SendAfterUTC?: Date;
	public SentOnUTC?: Date;
}